// 导入vue包
import Vue from "vue";

// 导入根组件App
import App from "./App";

// 导入路由包
import router from "./router";

// 导入vuex
import store from "./store";

// http请求
import http from "./request/http";
import api from "./request/api";
Vue.prototype.$http = http;
Vue.prototype.$api = api;

// 淘宝适配方案
import 'lib-flexible'

// swiper
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(vueSwiper)
 
// 导入Mint组件库
import Mint from "mint-ui";
import "mint-ui/lib/style.css";
Vue.use(Mint);

// css样式重置
import '@/assets/css/reset.css'
// 引入图标
import '@/assets/font/iconfont.css'

Vue.config.productionTip = false;

// 第一次加载main.js的时候就设置根节点的（html节点）font-size。否则会出现混乱页面
window.onresize = setHtmlFontSize;

function setHtmlFontSize() {
  const htmlWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  const htmlDom = document.getElementsByTagName("html")[0];
  htmlDom.style.fontSize = htmlWidth / 10 + "px";
}
setHtmlFontSize();

// 实例化 挂载
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
